import type { IRowNode } from 'ag-grid-community'
import type { GridOrder } from './types'

export function RunoutComparator(_: GridOrder, __: GridOrder, nodeA: IRowNode<GridOrder>, nodeB: IRowNode<GridOrder>) {
  const endA = nodeA?.data?.tank_dispatch_window_end ?? nodeA?.data?.dispatch_window_end ?? ''
  const endB = nodeB?.data?.tank_dispatch_window_end ?? nodeB?.data?.dispatch_window_end ?? ''
  if (
    nodeA?.data?.type?.toLowerCase() === 'backhaul' &&
    (nodeB?.data?.type?.toLowerCase() === 'regular' || nodeB?.data?.type?.toLowerCase() === 'site delivery')
  ) {
    return 1
  }
  if (
    (nodeA?.data?.type?.toLowerCase() === 'regular' || nodeA?.data?.type?.toLowerCase() === 'site delivery') &&
    nodeB?.data?.type?.toLowerCase() === 'backhaul'
  ) {
    return -1
  }
  if (endA === endB) {
    return 0
  }
  if (endA > endB) {
    return 1
  }
  return -1
}

export function DeliveryWindowComparator(
  _: GridOrder,
  __: GridOrder,
  nodeA: IRowNode<GridOrder>,
  nodeB: IRowNode<GridOrder>
) {
  const startA = nodeA?.data?.carrier_window_start || nodeA?.data?.dispatch_window_start || ''
  const startB = nodeB?.data?.carrier_window_start || nodeB?.data?.dispatch_window_start || ''
  const endA = nodeA?.data?.carrier_window_end || nodeA?.data?.dispatch_window_end || ''
  const endB = nodeB?.data?.carrier_window_end || nodeB?.data?.dispatch_window_end || ''
  if (startA < startB) {
    return -1
  }
  if (startA > startB) {
    return 1
  }
  // Start dates are equal, compare end dates
  if (endA < endB) {
    return -1
  }
  if (endA > endB) {
    return 1
  }
  // End dates are also equal, the items are considered equal
  return 0
}
